import {
  Component,
  ComponentInterface,
  h,
  Prop,
  State,
  Watch,
} from '@stencil/core';
import { Maybe } from '../../global/types';
import { getModel } from './api/getModel';
import { RuntimeDisplay, RuntimeModel } from './types';

@Component({
  tag: 'runtime-view',
  styleUrl: 'runtime-view.css',
  shadow: true,
})
export class RuntimeView implements ComponentInterface {
  /**
   * URL of remote service from where data for runtimes should be retrieved
   */
  @Prop({
    attribute: 'data-url',
  })
    url: Maybe<string>;

  /**
   * Runtime display mode
   * @default default
   */
  @Prop({
    attribute: 'data-display',
  })
    display: RuntimeDisplay;

  @Prop({
    attribute: 'data-locale',
  })
    locale: string;

  @Prop({
    attribute: 'data-show',
  })
    show = true;

  @Watch('url')
  handlePropChange() {
    this.getModel(this.url);
  }

  /**
   * Method to retrieve product url from product id (it is a workaround backend not sending product url)
   */
  @Prop()
    getProductUrlById: (id: string) => Promise<string> = () => null;

  @State() loading = false;
  @State() model: Maybe<RuntimeModel>;

  private cancel: Maybe<(message: any) => any>;

  connectedCallback() {
    this.getModel(this.url);
  }

  cancelRequest(msg = '') {
    if (this.cancel) {
      this.cancel(msg);
    }
  }

  disconnectedCallback() {
    this.cancelRequest('Component disconnected');
  }

  async getModel(url?: string) {
    if (!url) {
      this.model = undefined;
      return;
    }
    try {
      this.model = undefined;
      setTimeout(() => {
        this.loading = true;
      }, 0);
      this.cancelRequest('Model url is outdated');
      this.model = await getModel(
        url,
        (c) => {
          this.cancel = c;
        },
        this.getProductUrlById,
      );
    } catch (e) {
      // silent error
    } finally {
      this.loading = false;
      this.cancel = undefined;
    }
  }

  render() {
    if (!this.show) {
      return null;
    }
    if (this.loading) {
      return <rt-loader></rt-loader>;
    }
    if (this.model) {
      return (
        <rt-runtime
          model={this.model}
          display={this.display}
          locale={this.locale}
        ></rt-runtime>
      );
    }
    return <rt-error-placeholder></rt-error-placeholder>;
  }
}
